import { useQuery } from '@apollo/client';
import React from 'react';
import { Outlet } from 'react-router';
import * as styles from './ExtensionApp.module.scss';
import { SessionActions } from '../../account/sessionSlice';
import { gql } from '../../graphql/generated';
import { IsExtensionProvider } from '../../utils/useIsExtension';
import { useAppDispatch } from '../redux/useAppSelector';

const EXTENSION_SESSION_QUERY = gql(/** @complexity 16 */ `
  query extensionSession {
    currentSession {
      ...startSession_session
    }
  }
`);

const ExtensionApp = () => {
  const dispatch = useAppDispatch();

  useQuery(EXTENSION_SESSION_QUERY, {
    onCompleted(data) {
      dispatch(SessionActions.startSession(data.currentSession));
    },
  });

  return (
    <IsExtensionProvider>
      <div className={styles.container}>
        <Outlet />
      </div>
    </IsExtensionProvider>
  );
};

export default ExtensionApp;
